module.exports = __webpack_public_path__ + "img/add.50ae74eb.svg";